import React, { useEffect } from 'react';
import { c1 } from '../../json/c1';
import './c1.css';


const C1 = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

  return (
    <div className='container'>
        <div className='row'>
            <div>
                <h3 className='title'>Sistema de Control Interno</h3>
                <hr className='hr-gob'/>



                 <p style={{ textAlign: 'justify' }}> 

                 La Secretaría de Turismo del Estado de Hidalgo, en apego a las disposiciones jurídicas aplicables referentes al Sistema de Control Interno Institucional (SCII), difunde los elementos que promueven la consecución de los objetivos de la dependencia, previenen los riesgos que propicien actos de corrupción y fraudes, así como la inclusión de tecnologías de información en los procesos institucionales. Esto se realiza promoviendo valores de integridad y comportamiento ético de los trabajadores, fortaleciendo la rendición de cuentas y transparencia.

                <br /><br />
                 En atención al principio de máxima publicidad de la información, se pone a consulta pública el desarrollo del Control Interno de esta institución del Gobierno del Estado de Hidalgo. </p>   


            </div>
                {
                c1.map((item, index)=>(
                    <div key={ index } className='col-md-3 col-sm-6 col-12'>
                        <div className='card_container_c1'>
                            <div className='card_anio'>
                                <h5>{ item.anio }</h5>
                                <h6>{ item.descripcion }</h6>
                                {
                                    item.trimestres.map((trim, index)=>(
                                        <div key={ index } className='card_trimestre'>
                                            <p>{ trim.trimestre } <span className="badge bg-secondary">
                                                <a href={ trim.url } target="_blank">.detalle</a></span>
                                            </p> 
                                        </div>
                                ))
                                }
                            </div>
                        </div>
                    </div>
                    ))
                }
        </div>
  
    </div>
  )
}

export default C1